import { createAsyncThunk, createSlice, /* createAsyncThunk */ } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { fetchEvent } from "../event/slice";
import { holderFeature } from "../holder";
// import service from '../events/service'
import adapter from './adapter'

const NAME = 'eventForm'

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: getInitialFormEmpty(),

  holder: {
    gallery: {
      create: [],
      delete: []
    },
  },
};

export const reset = createAsyncThunk(
  `${NAME}/reset`,
  async (options) => {
    return options
  }
);

export const eventFormSlice = createSlice({
  name: "eventForm",
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },

    ...holderFeature.generateReducer()
  },
  extraReducers: {
    [reset.fulfilled]: (state) => {
      state.data = getInitialFormEmpty()
    },
    [fetchEvent.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const payload = adapter.responseBodyToForm(action.payload);
      state.data = payload;
    },
  }
});

function getInitialFormEmpty(){
  return {
    title_en: '',
    title_id: '',
    registrationType: 'external',
    external_link: '',
    guest_total: 0,
    guest_seat: 0,
    visibility: 'public',
    registration_start_date: dayjs().format('YYYY-MM-DD'),
    registration_end_date: dayjs().format('YYYY-MM-DD'),
    event_start_date: dayjs().format('YYYY-MM-DD'),
    event_end_date: dayjs().format('YYYY-MM-DD'),
    about_en: 'N/A',
    about_id: 'N/A',
    province: '',
    city: '',
    address: '',
    pin_point: null,
    suitable: [],
    approach: [],
    issue: [],
    tags: [],
    location_online_id: null,
    location_online_channel: null,
    location_online_url: null,
    location_online_email: '',
    location_online_phone: '',
    location_online_need_update: false
  }
}

export const {
  setStatus,
  updateForm,
  addToHolder,
  emptyHolder
} = eventFormSlice.actions

export default eventFormSlice.reducer;
